import { render, staticRenderFns } from "./creat-image.vue?vue&type=template&id=f967afb0&scoped=true"
import script from "./creat-image.vue?vue&type=script&lang=js"
export * from "./creat-image.vue?vue&type=script&lang=js"
import style0 from "./creat-image.vue?vue&type=style&index=0&id=f967afb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f967afb0",
  null
  
)

export default component.exports